(function () {
  'use strict';

  angular
    .module('app.account-sponsorship', [])

    .component('accountSponsorShip', {
      bindings: {
        device: '<'
      },
      /* @ngInject */
      templateUrl: ["AccountService", function (AccountService) {
        return AccountService.getLinks().AccountSponsorShip;
      }],
      /* @ngInject */
      controller: ["$scope", "$rootScope", "$element", "$timeout", "$location", "AppService", "AccountService", "HttpService", "toastr", function ($scope, $rootScope, $element, $timeout, $location, AppService, AccountService, HttpService, toastr) {
        var ctrl = this;

        AccountService.initAccount(ctrl);

        ctrl.$onInit = function () {

          $scope.device = ctrl.device;

          ctrl.loading = true;

          AppService.getParams()
            .then(function (params) {
              if (!params.Account.IsManagementSponsorShip) {
                $location.path(ctrl.links.AccountHome);
              }
            })
            .catch(function (error) {
              console.error(error);
            });
        };

        // Translate
        var tplTranslate = {};
        $element.children('.translate').children().each(function () {
          var $this = $(this);
          tplTranslate[$this.attr('key')] = $this.html();
        });

        ctrl.formData = {
          Sponsors: [{}],
          Message: ''
        };

        ctrl.addSponsor = function () {
          ctrl.formData.Sponsors.push({});
        };
        ctrl.removeSponsor = function (index) {
          ctrl.formData.Sponsors.splice(index, 1);
        };

        ctrl.getSponsors = function (id) {
          ctrl.IDCampaign = id;
          ctrl.loading = true;
          HttpService.post({
            url: 'AccountSponsorShip/Get',
            data: {
              idCampaign: id
            }
          })
          .then(function (response) {
            ctrl.sponsors = response.results.sponsors;
            ctrl.loading = false;
          })
          .catch(function (error) {
            console.error(error);
          });
        };

        ctrl.submit = function () {

          $rootScope.$broadcast('showPageLoader', true);

          ctrl.formData.errors = {};

          HttpService.post({
            url: ctrl.links.AccountSponsorShip,
            data: ctrl.formData
          })
          .then(function (response) {
            if (response.status === 'OK') {
              ctrl.formData = {
                Sponsors: [{}],
                Message: ''
              };
              toastr.success('', ctrl.formData.Sponsors.length > 1 ? tplTranslate.multiCallOK : tplTranslate.singleCallOK, {
                allowHtml: true,
                extraData: {
                  template: 'toast_message.tpl'
                }
              });
            } else {
              // Traitement des erreurs
              var sponsors = [];
              _.each(response.errors, function (error) {
                if (error.Error === 'GODSON_ALREADY_CUSTOMER') {
                  toastr.warning('', error.Name + ' ' + tplTranslate.Error_GODSON_ALREADY_CUSTOMER, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                } else if (error.Error === 'ONE_PAID_ORDER_REQUIRED') {
                  toastr.warning('', tplTranslate.Error_ONE_PAID_ORDER_REQUIRED, {
                    allowHtml: true,
                    extraData: {
                      template: 'toast_message.tpl'
                    }
                  });
                }
                sponsors.push({
                  Name: error.Name,
                  Email: error.Email
                });
              });

              // Confirmation si certaines invitations sont envoyées
              var diff = ctrl.formData.Sponsors.length - sponsors.length;
              if (diff > 0) {
                toastr.success('', diff > 1 ? tplTranslate.multiCallOK : tplTranslate.singleCallOK, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              }

              // Mise à jour du model, les invitations envoyées sont supprimées
              var message = sponsors.length ? ctrl.formData.Message : '';
              ctrl.formData = {
                Sponsors: sponsors.length ? sponsors : [{}],
                Message: message
              };
            }
            // Reset de la validation du formulaire
            $timeout(function () {
              ctrl.form.$resetValidation();
            });
            ctrl.getSponsors(ctrl.IDCampaign);
            $rootScope.$broadcast('showPageLoader', false);
          })
          .catch(function (response) {
            console.error(response);
          });
        };

      }],
      controllerAs: 'accountCtrl'
    });

})();
